import { type Instance, types } from 'mobx-state-tree';

const CredentialInfo = types.model('CredentialInfo', {
  name: types.string,
  values: types.array(types.string),
});

export const Verification = types.model('Verification', {
  title: types.string,
  credentialInfo: types.array(CredentialInfo),
});

export interface IVerification extends Instance<typeof Verification> {}
